import React from "react"
import { PriceTierElements } from "./price-tier-types"
import "./price-tier.module.scss"
interface PriceTierProps {
  priceTier: PriceTierElements
  priceTerm: string
  hideInitialFee?: boolean
}

export const PriceTier = ({ priceTier, priceTerm, hideInitialFee = false }: PriceTierProps) => {
  const { price, initial_fee } = priceTier

  const priceTermTitle = priceTerm.endsWith("ly") ? priceTerm.slice(0, priceTerm.indexOf('ly')): priceTerm

  return (
    <div className="price-tier">
      <div className="price-tier__recurring u-flex-center-align">
        <div className="price-tier__price">{` $${price.value}`}</div>
        <p className="price-tier__recurring--title">{`/${priceTermTitle}* `}</p>
      </div>
      <p className={`price-tier__initial${hideInitialFee ? "--hide":""}  u-flex-center-align `}>
        <span className="price-tier__initial--title">{`Initial Service $${initial_fee.value}`}</span>
      </p>
    </div>
  )
}
